import { type PropsWithChildren } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { ImageProgressive } from '@mentimeter/ragnar-ui/image-progressive';

interface SideBySideImageProps {
  imageUrl: string;
  imageAltText?: string | undefined;
  imagePosition: 'start' | 'end';
  imageWidth?: '0%' | '10%' | '25%' | '33%' | '35%' | '50%' | '66%' | undefined;
}

export const SideBySideImage = ({
  children,
  imageUrl,
  imageAltText,
  imagePosition,
  imageWidth,
}: PropsWithChildren<SideBySideImageProps>) => {
  const flexDirection = imagePosition === 'start' ? 'row' : 'row-reverse';

  return (
    <Box flexDirection={flexDirection} width="100%" height="100%">
      <Box
        height="100%"
        width={imageWidth}
        justifyContent="center"
        alignItems="center"
        data-testid="side-by-side-image"
        px="space4"
      >
        <ImageProgressive src={imageUrl} alt={imageAltText || ''} />
      </Box>
      <Box flex="1" height="100%" justifyContent="center" alignItems="center">
        {children}
      </Box>
    </Box>
  );
};
